
(() => {
  let observer;
  let loading = false;
  let seeAll = false;

  function stopInfiniteScroll() {
    observer?.disconnect();
    observer = null;
    document.getElementById('collection-view-loader')?.remove();
  }

  function getNextPage() {
    const pagination = document.querySelector(
      '#ProductGridContainer .pagination'
    );

    if (!pagination) return null;

    const links = [...pagination.querySelectorAll('a[href]')];

    return links.find(link =>
      link.getAttribute('rel') === 'next' ||
      link.classList.contains('page-number-next') ||
      link.getAttribute('aria-label')?.toLowerCase().includes('next')
    ) || null;
  }

  async function loadNextPage() {
    if (loading || !seeAll) return;

    const nextLink = getNextPage();

    if (!nextLink) {
      stopInfiniteScroll();
      return;
    }

    const grid = document.querySelector('#product-grid');

    if (!grid) return;

    loading = true;

    const loader = document.getElementById('collection-view-loader');
    if (loader) loader.textContent = 'Loading more products...';

    try {
      const response = await fetch(nextLink.href);

      if (!response.ok) {
        throw new Error('Unable to load the next page');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const newPagination = doc.querySelector(
        '#ProductGridContainer .pagination'
      );
      const currentPagination = document.querySelector(
        '#ProductGridContainer .pagination'
      );

      if (!newGrid) {
        throw new Error('Product grid not found');
      }

      grid.append(...newGrid.children);

      if (currentPagination && newPagination) {
        currentPagination.replaceWith(newPagination);
      } else {
        currentPagination?.remove();
      }

      if (!getNextPage()) {
        stopInfiniteScroll();
      }
    } catch (error) {
      console.error('See all:', error);

      if (loader) {
        loader.textContent =
          'Could not load more products. Scroll to try again.';
      }
    } finally {
      loading = false;
    }
  }

  function startInfiniteScroll() {
    stopInfiniteScroll();
    seeAll = true;

    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const loader = document.createElement('div');
    loader.id = 'collection-view-loader';
    loader.textContent = 'Scroll down to see more products';
    loader.style.cssText =
      'text-align:center;padding:24px;font-size:14px;';

    grid.after(loader);

    observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadNextPage();
      }
    }, {
      rootMargin: '1500px'
    });

    observer.observe(loader);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-view="all"]');

    if (!button) return;

    event.preventDefault();

    document.querySelectorAll('.collection-view-options a')
      .forEach(link => link.classList.remove('active'));

    button.classList.add('active');

    startInfiniteScroll();
  });
})();


function updateCollectionViewSelection() {
  const params = new URLSearchParams(window.location.search);
  const is48 = params.get('view') === 'view-48';

  document.querySelectorAll('.collection-view-options a').forEach(link => {
    const label = link.textContent.trim();
    const isSeeAll = link.dataset.view === 'all';

    link.classList.toggle(
      'active',
      isSeeAll
        ? window.collectionSeeAllSelected === true
        : !window.collectionSeeAllSelected &&
          (is48 ? label === '48' : label === '20')
    );
  });
}

document.addEventListener('DOMContentLoaded', updateCollectionViewSelection);

document.addEventListener('click', event => {
  if (event.target.closest('.collection-view-options [data-view="all"]')) {
    window.collectionSeeAllSelected = true;
    updateCollectionViewSelection();
  }
});
